import { InfoBox, RawInfoBox } from '@activebrands/core-web/libs/storyblok/storyblok';
import { transformButton } from '@activebrands/core-web/libs/storyblok/utils/transform-buttons';

export const transformInfoBox = (box: RawInfoBox): InfoBox => {
    const { button, heading, paragraph, visibilitySettings } = box;

    return {
        button: button?.length > 0 ? transformButton(button[0]) : undefined,
        paragraph: paragraph?.length > 0 ? paragraph?.[0]?.richText : undefined,
        heading: heading?.length > 0 ? heading?.[0]?.text : undefined,
        visibilitySettings,
        show: true,
    };
};

export const transformInfoBoxes = (boxes: Array<RawInfoBox>): Array<InfoBox> =>
    boxes?.map(box => transformInfoBox(box));
